export enum BatchMailingStatus {
  NO_DATA = 'not_data',
  REDIRECTED = 'redirected',
  ON_THE_ROAD = 'on_the_road',
  REJECTED = 'rejected',
  PICKUP = 'pickup',
  AWARDED = 'awarded',
}
